module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--rules@2x-82959d6c81a442256406d01bb91bf7a6.jpg";